import clsx from 'clsx'
import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  hover?: boolean
  onClick?: () => void
}

export default function Card({ children, className, hover, onClick }: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-xl border border-border-strong/50 p-4',
        hover && 'cursor-pointer hover:border-primary/40 hover:shadow-md hover:shadow-primary/5 transition-all',
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
